var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonScatterHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#001829"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(391 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -120.8L77.6 -92.5L118.9 -21L104.6 60.4L41.3 113.5L-41.3 113.5L-104.6 60.4L-118.9 -21L-77.6 -92.5Z",
    fill: "#297EA6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(685 569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -92L59.1 -70.5L90.6 -16L79.7 46L31.5 86.5L-31.5 86.5L-79.7 46L-90.6 -16L-59.1 -70.5Z",
    fill: "#297EA6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(854 361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -109L70.1 -83.5L107.3 -18.9L94.4 54.5L37.3 102.4L-37.3 102.4L-94.4 54.5L-107.3 -18.9L-70.1 -83.5Z",
    fill: "#297EA6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(711 57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -76L48.9 -58.2L74.8 -13.2L65.8 38L26 71.4L-26 71.4L-65.8 38L-74.8 -13.2L-48.9 -58.2Z",
    fill: "#297EA6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -94L60.4 -72L92.6 -16.3L81.4 47L32.1 88.3L-32.1 88.3L-81.4 47L-92.6 -16.3L-60.4 -72Z",
    fill: "#297EA6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88 505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -102L65.6 -78.1L100.5 -17.7L88.3 51L34.9 95.8L-34.9 95.8L-88.3 51L-100.5 -17.7L-65.6 -78.1Z",
    fill: "#297EA6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(321 594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -93L59.8 -71.2L91.6 -16.1L80.5 46.5L31.8 87.4L-31.8 87.4L-80.5 46.5L-91.6 -16.1L-59.8 -71.2Z",
    fill: "#297EA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonScatterHaikei);
export default __webpack_public_path__ + "static/media/polygon-scatter-haikei.6d73f25f2c7e846455a4cbcdb46f406c.svg";
export { ForwardRef as ReactComponent };